import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { Provider } from 'react-redux';

import MRClient from './vendor/mr-client.min';

import { ClientProvider } from './contexts';
import App from './features/App/App';
import store from './reducers/store';

import * as serviceWorker from './serviceWorker';

import './index.css';

// Initialize MRClient SDK
const mrClient = new MRClient({
  apiUrl: process.env.REACT_APP_MR_CLIENT_API_URL,
  clientId: process.env.REACT_APP_MR_CLIENT_ID,
  clientSecret: process.env.REACT_APP_MR_CLIENT_SECRET,
});
const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <ClientProvider client={mrClient}>
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </ClientProvider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
